export const REVIEW_BOOKING = "REVIEW_BOOKING";
export const ON_LOADING = "ON_LOADING";
export const OFF_LOADING = "OFF_LOADING";

export const ADD_SLOTID = "ADD_SLOTID";

export const SELECT_HOSPITAL = "schedules/SELECT_HOSPITAL";

export const SET_PARTNER_ID = "schedules/SET_PARTNER_ID";

export const RESET_BOOKING_TREE = "schedules/RESET_BOOKING_TREE";

export const GET_BOOKING_TREE = "schedules/GET_BOOKING_TREE";
export const GET_BOOKING_TREE_SUCCESS = "schedules/GET_BOOKING_TREE_SUCCESS";

export const GET_SUB_BOOKING_TREE = "schedules/GET_SUB_BOOKING_TREE";
export const GET_SUB_BOOKING_TREE_SUCCESS =
  "schedules/GET_SUB_BOOKING_TREE_SUCCESS";

export const SELECT_SUBJECT = "schedules/SELECT_SUBJECT";
export const RESET_SELECT_SUBJECT = "schedules/RESET_SELECT_SUBJECT";
export const SEARCH_SUBJECT = "schedules/SEARCH_SUBJECT";

export const SELECT_SERVICE = "schedules/SELECT_SERVICE";
export const RESET_SELECT_SERVICE = "schedules/RESET_SELECT_SERVICE";

export const SELECT_ROOM = "schedules/SELECT_ROOM";
export const RESET_SELECT_ROOM = "schedules/RESET_SELECT_ROOM";

export const SELECT_DOCTOR = "schedules/SELECT_DOCTOR";
export const RESET_SELECT_DOCTOR = "schedules/RESET_SELECT_DOCTOR";
export const SEARCH_DOCTOR = "schedules/SEARCH_DOCTOR";

export const SELECT_DATE = "schedules/SELECT_DATE";
export const RESET_SELECT_DATE = "schedules/RESET_SELECT_DATE";

export const SELECT_TIME_SLOT = "schedules/SELECT_TIME_SLOT";
export const RESET_SELECT_TIME_SLOT = "schedules/RESET_SELECT_TIME_SLOT";

export const RESET_DATA = "schedules/RESET_DATA";

export const RESERVE_BOOKING = "schedules/RESERVE_BOOKING";
export const RESERVE_BOOKING_SUCCESS = "schedules/RESERVE_BOOKING_SUCCESS";
export const RESERVE_BOOKING_FAILURE = "schedules/RESERVE_BOOKING_FAILURE";

export const RESERVE_MULTIPLE_BOOKINGS = "schedules/RESERVE_MULTIPLE_BOOKINGS";
export const RESERVE_MULTIPLE_BOOKINGS_SUCCESS =
  "schedules/RESERVE_MULTIPLE_BOOKINGS_SUCCESS";
export const RESERVE_MULTIPLE_BOOKINGS_FAILURE =
  "schedules/RESERVE_MULTIPLE_BOOKINGS_FAILURE";

export const GET_PAYMENT_INFO = "schedules/GET_PAYMENT_INFO";
export const GET_PAYMENT_INFO_SUCCESS = "schedules/GET_PAYMENT_INFO_SUCCESS";

export const GET_BOOKING_INFO = "schedules/GET_BOOKING_INFO";
export const GET_BOOKING_INFO_SUCCESS = "schedules/GET_BOOKING_INFO_SUCCESS";

export const ADD_SCHEDULE = "schedules/ADD_SCHEDULE";
export const ADD_SCHEDULE_REPAYMENT = "schedules/ADD_SCHEDULE_REPAYMENT";
export const RESET_SCHEDULE = "schedules/RESET_SCHEDULE";

export const CHANGE_DIRECTION = "schedules/CHANGE_DIRECTION";

export const GET_ALL_MEDICAL_BILLS = "schedules/GET_ALL_MEDICAL_BILLS";
export const GET_ALL_MEDICAL_BILLS_SUCCESS =
  "schedules/GET_ALL_MEDICAL_BILLS_SUCCESS";
export const GET_ALL_MEDICAL_BILLS_FAILURE =
  "schedules/GET_ALL_MEDICAL_BILLS_FAILURE";

export const GET_ALL_HIDDEN_MEDICAL_BILLS =
  "schedules/GET_ALL_HIDDEN_MEDICAL_BILLS";
export const GET_ALL_HIDDEN_MEDICAL_BILLS_SUCCESS =
  "schedules/GET_ALL_HIDDEN_MEDICAL_BILLS_SUCCESS";
export const GET_ALL_HIDDEN_MEDICAL_BILLS_FAILURE =
  "schedules/GET_ALL_HIDDEN_MEDICAL_BILLS_FAILURE";

export const SELECT_MEDICAL_BILL = "schedules/SELECT_MEDICAL_BILL";

export const CHECK_REPAYMENT = "schedules/CHECK_REPAYMENT";
export const REPAYMENT_BOOKING = "schedules/REPAYMENT_BOOKING";

export const CHANGE_SERVICE_TYPE = "schedules/CHANGE_SERVICE_TYPE";

export const CHANGE_BOOKING_FLOW = "schedules/CHANGE_BOOKING_FLOW";

export const RESET_LIST_NODE = "schedules/RESET_LIST_NODE";

export const RESERVE_PAYMENT_PARTNER = "RESERVE_PAYMENT_PARTNER";

export const REMOVE_SCHEDULE = "schedules/REMOVE_SCHEDULE";

export const UPDATE_CURRENT_NODE = "schedules/UPDATE_CURRENT_NODE";

export const GO_BACK_STEP = "schedules/GO_BACK_STEP";

export const SET_INSURANCE_CHOICE = "schedules/SET_INSURANCE_CHOICE";

export const SET_SCHEDULE_WITHOUT_DATE = "schedules/SET_SCHEDULE_WITHOUT_DATE";

export const BOOKING_SHARE_TO_PAGE = "schedules/BOOKING_SHARE_TO_PAGE";
export const BOOKING_SHARE_TO_PAGE_SUCCESS =
  "schedules/BOOKING_SHARE_TO_PAGE_SUCCESS";
export const BOOKING_SHARE_TO_PAGE_FAILURE =
  "schedules/BOOKING_SHARE_TO_PAGE_FAILURE";

export const GET_EXTRA_CONFIG = "GET_EXTRA_CONFIG";

export const GET_EXTRA_CONFIG_SUCCESS = "GET_EXTRA_CONFIG_SUCCESS";

export const RESET_RESETPAYMENTINFORMATION = "RESET_RESETPAYMENTINFORMATION";

export const HOSPITAL_INFO = "HOSPITAL_INFO";

export const HOSPITAL_DESCRIPTION = "HOSPITAL_DESCRIPTION";
